export default __webpack_public_path__ + "static/media/DS11.27919556.jpg";